import {
  PiBook,
  PiBookBookmark,
  PiBookOpenText,
  PiDeviceTablet,
  PiGlobe,
  PiHeadphones,
  PiPackage,
} from "react-icons/pi";
import type { IconType } from "react-icons";

const BINDING_ICONS: ReadonlyArray<[RegExp, IconType]> = [
  [/lydbok|lydfil|cd|mp3/, PiHeadphones],
  [/e-?bok|epub|digital/, PiDeviceTablet],
  [/nettsted|nettressurs|abonnement|lisens/, PiGlobe],
  [/kombinasjon|pakke/, PiPackage],
  [/innbundet|kartonert|spiral/, PiBookBookmark],
  [/heftet|fleksibind|pocket/, PiBookOpenText],
];

export function getBindingIcon(binding: string): IconType {
  const normalized = binding.toLowerCase();
  const match = BINDING_ICONS.find(([pattern]) => pattern.test(normalized));
  return match ? match[1] : PiBook;
}
